import EntitySearch from '../commons/entitySearch'
import store from '../../store'
import API, { APIResponse } from '../commons/api'
import { FunctionProperty } from '../commons/appFunction'
import WbsItemApi from './wbsItem'

export interface GetTasksProps {
  projectUuid: string
  displayName: string
  type: string
  offset?: number
  limit?: number
}

class Task extends EntitySearch {
  public search = async (
    rawQuery: string,
    data?: any,
    uiMeta?: FunctionProperty
  ) => {
    return this.searchInternal(
      rawQuery,
      (query: string) => ({
        projectUuid: store.getState().project.selected,
        displayName: query,
        limit: query.length === 0 ? 10 : undefined,
      }),
      this.toResponse
    )
  }

  public searchAll = async () => {
    return this.searchInternal(
      '',
      () => ({
        projectUuid: store.getState().project.selected,
      }),
      this.toResponse
    )
  }

  toResponse = (response: any) => ({
    uuid: response.task.uuid,
    code: response.task.code,
    name: `[${response.task.code}] ${response.task.displayName}`,
    displayName: response.task.displayName,
  })

  entitySearchApi = (
    props: GetTasksProps,
    signal?: AbortSignal
  ): Promise<APIResponse> => {
    if (!props.limit) {
      props.limit = 10
    }
    return API.functional.request(
      'GET',
      '/api/v1/projects/task_actual_works/find', // FIXME: task#AWPUEHKF
      props,
      true,
      signal
    )
  }

  getByUuidInternal = async (uuid: string): Promise<APIResponse> => {
    const response = await WbsItemApi.getDetail({ uuid })
    return { status: 200, json: this.toResponse(response.json) }
  }
}

export default new Task()
